
import React from 'react';
import Courier from '../../asset/Feature/Courier.png'
import Bank from '../../asset/Feature/Bank.png'
import Printing from '../../asset/Feature/Printing.png'
import Hotel from '../../asset/Feature/Hotel.png'
import Medical from '../../asset/Feature/Medical.png'
import Resturant from '../../asset/Feature/Resturant.png'
import { useLocation } from 'react-router-dom';

const Feature = ({ icon, title, description }) => (
  <div className="flex flex-col items-center text-center px-2 sm:px-4 py-4 sm:py-6">
    <img src={icon} alt={title} className="w-10 h-10 sm:w-14 sm:h-14 object-contain mb-3 sm:mb-4" />
    <h3 className="text-[#0B2549] font-sans text-lg sm:text-xl font-semibold mb-2 sm:mb-3">{title}</h3>
    <p className="text-[#6D7E94] font-sans text-xs sm:text-sm leading-relaxed">
      {description}
    </p>
  </div>
);

export const FeaturesSection=() => {

  const location = useLocation();
  const isperungudi = location.pathname === '/perungudi-chennai' || location.pathname === '/affordable-coworking-space-perungudi';

  const features = [
    {
      icon: "https://cdn.builder.io/api/v1/image/assets/156ea696819743bb881fd4ebbe99ea1e/291d728e0cd83c469a3ce12de2b1d6dab850a2dc?placeholderIfAbsent=true",
      title: isperungudi ? "Rail Access" : "Metro Access",
      description: isperungudi ? "Near Taramani & Tiruvanmiyur Stations + ECR/OMR For Smooth Travel" :  "2-Minute Walk To Thousand Lights Metro For Easy Daily Commute."
    },
    {
      icon: "https://cdn.builder.io/api/v1/image/assets/156ea696819743bb881fd4ebbe99ea1e/665251c6474df90758a3de8c98fcb07a6f8b5bc1?placeholderIfAbsent=true",
      title: "Bus Connectivity",
      description: "Located Beside Major MTC Stops For Smooth Travel."
    },
    {
      icon: Resturant,
      title: "Restaurants",
      description: isperungudi ? "ECR Food Stretch & Popular Cafes Right Around The Corner." :  "Variety Of Restaurants For Team Lunches Or Client Meetings."
    },
    {
      icon: Bank,
      title: "Banking Access",
      description: "Multiple ATMs And Banks Located Within Walking Distance."
    },
    {
      icon: Hotel,
      title: isperungudi ? "Stay & PG Options" : "Hotel Proximity",
      description: isperungudi ? "Hotels, PGs & Co-Living Spaces For Clients Or Visiting Teams." : "Stay Options Nearby For Clients Or Visiting Team Members."
    },
    {
      icon: Courier,
      title: "Courier Services",
      description: "Nearby Courier Points Make Business Logistics Seamless."
    },
    {
      icon: Printing,
      title: "Printing Service",
      description: "Print Shops And Services Available Right Outside Our Building."
    },
    {
      icon: Medical,
      title: "Medical Access",
      description: isperungudi ? "Hospitals, Clinics & Pharmacies Within 10 Minutes." : "Hospitals And Clinics Within 5 Minutes."
    }
  ];

  return (
    <section className="py-8 sm:py-16 px-4 sm:px-6 text-center bg-white">
      <h2 className="text-[#966376] font-sans text-base sm:text-lg font-bold uppercase mb-2 sm:mb-3">
        WHY OUR {isperungudi ? 'Perungudi' : 'MOUNT ROAD'} LOCATION MATTERS.
      </h2>
      <h3 style={{lineHeight:1.4}} className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-5xl font-bold mt-2 sm:mt-3 mb-8 sm:mb-12 max-w-4xl mx-auto text-center px-4">
        Our prime location offers benefits that ensure your comfort
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 max-w-[75rem] mx-auto">
        {features.map((feature, index) => (
          <Feature key={index} {...feature} />
        ))}
      </div>
    </section>
  );
};
